import type { Animatronic } from '../types/animatronic';

export function generateAnimatronicSchema(animatronic: Animatronic) {
  return {
    '@context': 'https://schema.org',
    '@type': 'TouristAttraction',
    name: animatronic.name,
    description: animatronic.description,
    location: {
      '@type': 'Place',
      name: animatronic.park,
      address: {
        '@type': 'PostalAddress',
        addressCountry: animatronic.country
      }
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: animatronic.gps_coordinates.split(',')[0],
      longitude: animatronic.gps_coordinates.split(',')[1]
    },
    image: animatronic.media?.[0]?.url,
    dateCreated: animatronic.year.toString(),
    additionalType: 'https://schema.org/TechnicalDevice'
  };
}

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Animatronic Database',
    description: 'Comprehensive database of animatronic figures, technical information, and educational resources about animatronic engineering and construction.',
    url: 'https://animatronicdatabase.com',
    logo: 'https://animatronicdatabase.com/android-chrome-512x512.png',
    sameAs: [
      'https://linkedin.com/company/animatronic-database'
    ],
    knowsAbout: [
      'Animatronics',
      'Robotics',
      'Mechanical Engineering',
      'Theme Park Technology',
      'Animatronic Design',
      'Control Systems',
      'Pneumatics',
      'Hydraulics',
      'Electric Actuators',
      'Motion Control'
    ]
  };
}

export function generateTechnicalArticleSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: 'How Animatronics Work: A Technical Guide',
    description: 'Learn about the engineering principles, components, and systems that power modern animatronic figures.',
    keywords: [
      'animatronics',
      'robotics',
      'mechanical engineering',
      'control systems',
      'pneumatics',
      'hydraulics',
      'electric actuators',
      'motion control',
      'animatronic design',
      'theme park technology'
    ],
    articleSection: 'Technical',
    audience: {
      '@type': 'Audience',
      audienceType: 'Engineers, Technicians, Theme Park Professionals, Hobbyists'
    }
  };
}